import fetch from '../utils/fetch'

export function getBankBrandList (query) {
  return fetch({
    url: '/bank/brand',
    method: 'get',
    params: query
  })
}

export function createBankBrand (query) {
  return fetch({
    url: '/bank/brand/create',
    method: 'post',
    params: query
  })
}

export function updateBankBrand (brandId, query) {
  return fetch({
    url: '/bank/brand/' + brandId,
    method: 'put',
    params: query
  })
}

export function deleteBankBrand (brandId) {
  return fetch({
    url: '/bank/brand/' + brandId,
    method: 'delete'
  })
}

export function getBankActivityList (query) {
  return fetch({
    url: '/bank/activity/getlist',
    method: 'get',
    params: query
  })
}

export function getBankActivityInfo (query) {
  return fetch({
    url: '/bank/activity/getinfo',
    method: 'get',
    params: query
  })
}

export function createBankActivity (query) {
  return fetch({
    url: '/bank/activity/create',
    method: 'post',
    params: query
  })
}

export function updateBankActivity (query) {
  return fetch({
    url: '/bank/activity/update',
    method: 'put',
    params: query
  })
}

export function getBankActivityItemList (query) {
  return fetch({
    url: '/bank/activity/getItemList',
    method: 'get',
    params: query
  })
}

export function copyBankActivity (query) {
  return fetch({
    url: '/bank/activity/copy',
    method: 'post',
    params: query
  })
}
